import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import Console from './Console'
import Login from './Auth/Login'
import Logout from './Auth/Logout'
import PrivateRoute from './Core/PrivateRoute'
import Signup from './Auth/Signup'
import ResetPassword from './Auth/ResetPassword'
import ResetPasswordVerify from './Auth/ResetPasswordVerify'

import { UserContext } from '../context'

let Routes = ({ user }) => (
  <UserContext.Consumer>
    {user => (
      <Router>
        <Switch>
          <Route
            exact
            path="/"
            render={() =>
              user ? <Redirect to="/console" /> : <Redirect to="/login" />
            }
          />
          <Route exact path="/login" component={Login} />
          <Route exact path="/signup" component={Signup} />
          <Route exact path="/logout" component={Logout} />
          <Route exact path="/password-reset" component={ResetPassword} />
          <Route path="/password-reset-verify/:user_id/:password_reset_code" component={ResetPasswordVerify} />
          <PrivateRoute path="/console" component={Console} />
        </Switch>
      </Router>
    )}
  </UserContext.Consumer>
)

export default Routes
